import '@unocss/reset/tailwind.css'
import { createPinia } from 'pinia'
import 'virtual:uno.css'
import { createApp } from 'vue'
import App from './App.vue'
import globalComponents from './components'
import globalDirectives from './directives'
import router from './routes'
import './styles/style.css'

createApp(App)
  .use(createPinia())
  .use(router)
  .use(globalDirectives)
  .use(globalComponents)
  .mount('#app')
